import { render, staticRenderFns } from "./OutsourcedWorkOrder.vue?vue&type=template&id=825435fa&scoped=true"
import script from "./OutsourcedWorkOrder.vue?vue&type=script&lang=js"
export * from "./OutsourcedWorkOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825435fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('825435fa')) {
      api.createRecord('825435fa', component.options)
    } else {
      api.reload('825435fa', component.options)
    }
    module.hot.accept("./OutsourcedWorkOrder.vue?vue&type=template&id=825435fa&scoped=true", function () {
      api.rerender('825435fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OutsourcedWorkOrder/OutsourcedWorkOrder.vue"
export default component.exports